import { useAtom } from 'jotai';
import { isDebugModeAtom } from './DebugAtom';

export const useConfigDebugMode = () => {
    return useAtom(isDebugModeAtom);
};
